
(function () {
if (window.__csCartDrawer) return;
window.__csCartDrawer = true;

var COBUY_URL = document.getElementById('csCartDrawer').dataset.recommendationsUrl;
var RESERVE_MIN = 0 || 0;
var DEMAND_MIN = 1;
var DEMAND_LABEL = "claimed in the last 7 days";
var MAX_PIECES = 100;
var EXPIRED_MSG = "Your hold has run out — these are the last pieces, so please check out soon.";
var LIMIT_MSG = "Orders are limited to 100 items. Remove an item before adding another.";
var RECS_TITLE = "Often bought together";
var RECS_SUB = "More meaningful pieces to discover.";
var CROSS_TITLE = "Complete the set";
var CROSS_SUB = "The kinds of piece you have not picked yet, best sellers first.";
var SAME_TITLE = "More [type]";
var SAME_SUB = "More pieces for your collection.";
var BEST_TITLE = "Discover more";
var BEST_SUB = "Find a little reminder of faith.";
var ROW_SIZE = parseInt("10", 10) || 10;
var SOLDOUT_MODE = "show";
var SOLDOUT_LABEL = "Sold out";
var SOLDOUT_MSG = "That piece is currently unavailable.";
var DEMAND_SHORT = "claimed";
var UPSELL_TITLE = "A little extra";
var EMPTY_LINK = "\/collections\/all-jewelry";
var EMPTY_LABEL = "Browse our jewelry";
var TRUST1 = "Sunday and Soul — made with love, worn with faith.";
var TRUST2 = "Jewelry is $0. Shipping increases with your selection and is shown at checkout.";
var TRUST3 = "Handmade Christian jewelry.";

var SHOW_UPSELLS = false;
var UPSELLS = [
];
UPSELLS.sort(function (a, b) { return (a.cents || 0) - (b.cents || 0); });

var $ = function (id) { return document.getElementById(id); };
var drawer, veil, body, busy = false, DATA = null, fmt = null, fmtCur = null;
var dataRequest = null, cartRequest = null, cartCache = null, cartTime = 0, cartVersion = 0;
var productCache = {}, productRequests = {}, stockTimer = null;
var linesHTML = null, recommendationsHTML = null;
function rememberCart(cart) { cartCache = cart; cartTime = Date.now(); return cart; }
function invalidateCart() { cartVersion++; cartTime = 0; cartRequest = null; }
function imageURL(src, width) {
try {
var url = new URL(src, location.href);
if (url.hostname === 'cdn.shopify.com' || url.pathname.indexOf('/cdn/shop/') === 0) {
url.searchParams.set('width', width);
return url.href;
}
} catch (e) {}
return src || '';
}
function getProduct(handle) {
var cached = productCache[handle];
if (cached && Date.now() - cached.time < 60000) return Promise.resolve(cached.product);
if (productRequests[handle]) return productRequests[handle];
var request = jfetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
.then(function(r) {
if (r.status === 404) return { available: false, variants: [] };
if (!r.ok) throw new Error('Unable to load this piece. Please try again.');
return r.json();
}).then(function(product) { productCache[handle] = { product: product, time: Date.now() }; return product; })
.finally(function() { delete productRequests[handle]; });
productRequests[handle] = request;
return request;
}

function money(cents, cur) {
try {
if (!fmt || fmtCur !== cur) {
fmt = new Intl.NumberFormat(document.documentElement.lang || undefined,
{ style: 'currency', currency: cur });
fmtCur = cur;
}
return fmt.format(cents / 100);
} catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function icon(d, cls) {
return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' viewBox="0 0 24 24" fill="none" ' +
'stroke="currentColor" stroke-width="1.7" stroke-linecap="round" ' +
'stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
}
var IC = {
shield: '<path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/>',
hammer: '<path d="M14 4l6 6-3 3-6-6z"/><path d="M11 7L4 14v6h6l7-7"/>',
truck:  '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>',
hand:   '<path d="M12 21s-7-4.3-7-9.3A3.7 3.7 0 0 1 12 9a3.7 3.7 0 0 1 7 2.7c0 5-7 9.3-7 9.3z"/>',
flame:  '<path d="M12 3c3 3.5 5 6 5 9a5 5 0 0 1-10 0c0-1.6.7-3 2-4.5.4 1.2 1 2 2 2.3C11 8 11.4 5.6 12 3z"/>',
zoom:   '<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M8 10.5h5M10.5 8v5"/>',
zoomout:'<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M8 10.5h5"/>'
};

var clockTimer = null;
function startClock() {
if (!RESERVE_MIN) return;
var el = $('csCdRes'); if (!el) return;
var until = null;
try { until = parseInt(sessionStorage.getItem('cs_hold_until'), 10); } catch (e) {}
if (!until || until < Date.now()) {
until = Date.now() + RESERVE_MIN * 60000;
try { sessionStorage.setItem('cs_hold_until', String(until)); } catch (e) {}
}
el.hidden = false;
clearInterval(clockTimer);
var tick = function () {
var left = Math.max(0, until - Date.now());
var m = Math.floor(left / 60000), sec = Math.floor(left % 60000 / 1000);
var c = $('csCdClock');
if (left <= 0) {
clearInterval(clockTimer);
if (c) c.hidden = true;
var lab = $('csCdResLabel');
if (lab) lab.textContent = EXPIRED_MSG;
var rea = $('csCdResReason');
if (rea) rea.hidden = true;
return;
}
if (c) { c.hidden = false; c.textContent = m + ':' + (sec < 10 ? '0' : '') + sec; }
};
tick(); clockTimer = setInterval(tick, 1000);
}
var ours = false;
function jfetch(url, opts) {
ours = true;
var p;
try { p = fetch(url, opts); } finally { ours = false; }
return p;
}
function getCart(force) {
if (!force && cartCache && Date.now() - cartTime < 10000) return Promise.resolve(cartCache);
if (cartRequest) return cartRequest;
var version = cartVersion;
var request = jfetch('/cart.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
.then(function(r) { if (!r.ok) throw new Error('Unable to load your order.'); return r.json(); })
.then(function(cart) { return version === cartVersion ? rememberCart(cart) : getCart(); })
.finally(function() { if (cartRequest === request) cartRequest = null; });
cartRequest = request;
return request;
}
function loadData() {
if (DATA) return Promise.resolve(DATA);
if (dataRequest) return dataRequest;
dataRequest = jfetch(COBUY_URL).then(function(r) { if (!r.ok) throw new Error('Unable to load recommendations.'); return r.json(); })
.then(function(d) { DATA = d; return d; }).finally(function() { dataRequest = null; });
return dataRequest;
}
function pieceUnits(cart) {
return (cart.items || []).reduce(function (n, i) {
return n + i.quantity;
}, 0);
}
function atCap(cart) { return MAX_PIECES > 0 && pieceUnits(cart) >= MAX_PIECES; }

var noticeUntil = 0, soldNoticeUntil = 0;
function flagLimit() { noticeUntil = Date.now() + 12000; }
function flagSoldOut() { soldNoticeUntil = Date.now() + 12000; }

function demandFor(pid) {
var n = (DATA && DATA.sold) ? DATA.sold[String(pid)] : 0;
return (DEMAND_MIN && n && n >= DEMAND_MIN) ? n : 0;
}
var OUT = {}, H2P = null, checking = {};
var VERIFY_MAX = 8;
var OUT_KEY = 'cfCdSoldOut';

function loadOut() {
try { OUT = JSON.parse(sessionStorage.getItem(OUT_KEY) || '{}') || {}; } catch (e) { OUT = {}; }
}
function saveOut() {
try { sessionStorage.setItem(OUT_KEY, JSON.stringify(OUT)); } catch (e) {}
}
function metaOf(pid) { return (DATA && DATA.meta && DATA.meta[String(pid)]) || {}; }
function isOut(pid) {
var k = String(pid);
return OUT[k] !== undefined ? !!OUT[k] : !!metaOf(k).x;
}
function markOut(pid, gone) {
if (pid === undefined || pid === null || pid === '') return false;
var k = String(pid), v = gone ? 1 : 0, changed = isOut(k) !== !!gone;
if (OUT[k] !== v) { OUT[k] = v; saveOut(); }
return changed;
}
function pidOfHandle(h) {
if (!H2P) {
H2P = {};
Object.keys((DATA && DATA.meta) || {}).forEach(function (pid) { H2P[DATA.meta[pid].h] = pid; });
}
return H2P[h];
}
var stockQ = [];
function verifyStock() {
clearTimeout(stockTimer);
if (!DATA || !DATA.meta || !drawer.classList.contains('is-open')) return;
stockTimer = setTimeout(function() {
if (busy || !drawer.classList.contains('is-open')) return;
var todo = stockQ.filter(function(pid) { return !checking[pid] && metaOf(pid).k; }).slice(0, VERIFY_MAX);
var changed = false;
function worker() {
if (busy || !drawer.classList.contains('is-open')) return Promise.resolve();
var pid = todo.shift();
if (!pid) return Promise.resolve();
checking[pid] = 1;
return getProduct(metaOf(pid).h).then(function(prod) { changed = markOut(pid, !prod.available) || changed; })
.catch(function() { delete checking[pid]; }).then(worker);
}
Promise.all([worker(), worker()]).then(function() { if (changed && cartCache && !busy) render(cartCache); });
}, 400);
}
function variantLabel(item) {
var ov = item.options_with_values;
if (ov && ov.length) {
var parts = [];
for (var i = 0; i < ov.length; i++) {
var n = ov[i].name, v = ov[i].value;
if (!v || v === 'Default Title') continue;
parts.push(n && n !== 'Title' ? n + ': ' + v : v);
}
if (parts.length) return parts.join(' · ');
return '';
}
return (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
}
function plural(t) {
t = String(t || '').toLowerCase();
if (!t) return 'pieces';
return t.slice(-1) === 's' ? t : t + 's';
}

function buildRows(cart) {
if (!DATA || !DATA.meta) return [];
stockQ = [];
var meta = DATA.meta, inProd = {}, cartTypes = {}, typeCount = {};
(cart.items || []).forEach(function (i) {
var pid = String(i.product_id);
inProd[pid] = true;
var t = (meta[pid] || {}).y;
if (t) { cartTypes[t] = true; typeCount[t] = (typeCount[t] || 0) + i.quantity; }
});
var used = {}, usedTitle = {};
(cart.items || []).forEach(function (i) { usedTitle[i.product_title] = true; });
function take(ids, n) {
var out = [], gone = [];
for (var i = 0; i < ids.length && out.length + gone.length < n; i++) {
var id = String(ids[i]);
if (inProd[id] || used[id]) continue;
var m = meta[id];
if (!m || !m.i) continue;          // no image, no card
if (usedTitle[m.t]) continue;
if (m.k) stockQ.push(id);          // tracked: worth a live re-check after paint
var off = isOut(id);
if (off && SOLDOUT_MODE === 'hide') continue;
used[id] = true; usedTitle[m.t] = true;
(off ? gone : out).push({ id: id, meta: m, out: off });
}
return out.concat(gone);
}
var score = {};
Object.keys(inProd).forEach(function (pid) {
((DATA.cobuy || {})[pid] || []).forEach(function (x) {
if (inProd[x.id]) return;
score[x.id] = (score[x.id] || 0) + x.n;
});
});
var cobuyIds = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; });
if (!(cart.items || []).length) cobuyIds = (DATA.best || []).slice();
var others = [];
Object.keys(DATA.bytype || {}).forEach(function (t) { if (!cartTypes[t]) others.push(t); });
others.sort(function (a, b) { return (DATA.bytype[b] || []).length - (DATA.bytype[a] || []).length; });
var crossIds = [];
for (var r = 0; r < 24; r++) {         // round-robin, so one big category cannot own the row
for (var k = 0; k < others.length; k++) {
var list = DATA.bytype[others[k]] || [];
if (list[r]) crossIds.push(list[r]);
}
}
var mine = Object.keys(typeCount).sort(function (a, b) { return typeCount[b] - typeCount[a]; })[0];
if (!mine && !(cart.items || []).length) mine = Object.keys(DATA.bytype || {})[0];
var sameIds = mine ? (DATA.bytype[mine] || []) : [];

var rows = [
{ key: 'cobuy', title: RECS_TITLE, sub: RECS_SUB, items: take(cobuyIds, ROW_SIZE) },
{ key: 'cross', title: CROSS_TITLE, sub: CROSS_SUB, items: take(crossIds, ROW_SIZE) },
{ key: 'same', title: mine ? SAME_TITLE.replace('[type]', plural(mine)) : '',
sub: SAME_SUB, items: mine ? take(sameIds, ROW_SIZE) : [] },
{ key: 'best', title: BEST_TITLE, sub: BEST_SUB, items: take(DATA.best || [], ROW_SIZE) }
];
return rows.filter(function (r) { return r.title && r.items.length >= 2; });
}

function zoomIco() {
return '<span class="cs-cd__zoomico">' + icon(IC.zoom, 'cs-cd__gin') +
icon(IC.zoomout, 'cs-cd__gout') + '</span>';
}
function pickCard(o) {
return '<div class="cs-cd__card' + (o.on ? ' is-on' : '') + '">' +
'<button type="button" class="cs-cd__zoom" data-zoom aria-expanded="false" ' +
'aria-label="See a bigger picture of ' + esc(o.title) + '">' +
'<img class="cs-cd__cardimg" src="' + esc(imageURL(o.img, 200)) + '" data-full-src="' + esc(imageURL(o.img, 640)) + '" alt="" width="86" height="86" decoding="async" loading="lazy">' +
zoomIco() +
'</button>' +
'<div class="cs-cd__cardbody">' +
'<p class="cs-cd__cardname" title="' + esc(o.title) + '">' + esc(o.title) + '</p>' +
(o.blurb ? '<p class="cs-cd__cardsub">' + esc(o.blurb) + '</p>' : '') +
'<p class="cs-cd__cardprice">' + o.price + '</p>' +
'</div>' +
'<label class="cs-cd__pick">' +
'<input type="checkbox" data-toggle="' + o.id + '"' +
(o.key ? ' data-key="' + esc(o.key) + '"' : '') +
(o.on ? ' checked' : '') +
' aria-label="' + (o.on ? 'Remove ' : 'Add ') + esc(o.title) + '">' +
'<span class="cs-cd__track"><span class="cs-cd__knob"></span></span>' +
'<span class="cs-cd__picktx">' + (o.on ? 'Added' : 'Add') + '</span>' +
'</label></div>';
}

function card(o) {
return '<div class="cs-cd__card' + (o.out ? ' is-out' : '') + '">' +
'<button type="button" class="cs-cd__zoom" data-zoom aria-expanded="false" ' +
'aria-label="See a bigger picture of ' + esc(o.title) + '">' +
'<img class="cs-cd__cardimg" src="' + esc(imageURL(o.img, 200)) + '" data-full-src="' + esc(imageURL(o.img, 640)) + '" alt="" width="86" height="86" decoding="async" loading="lazy">' +
zoomIco() +
'</button>' +
'<div class="cs-cd__cardbody">' +
'<p class="cs-cd__cardname" title="' + esc(o.title) + '">' + esc(o.title) + '</p>' +
(o.blurb ? '<p class="cs-cd__cardsub">' + esc(o.blurb) + '</p>' : '') +
'<p class="cs-cd__cardprice">' + o.price +
(o.hot ? '<span class="cs-cd__hot">' + icon(IC.flame) + esc(o.hot) + '</span>' : '') +
'</p>' +
'</div>' +
(o.out ? '' :
'<button type="button" class="cs-cd__add" ' + o.attr + (o.disabled ? ' disabled' : '') + '>' +
esc(o.cta) + '</button>') + '</div>';
}

function trust(d, text) {
return '<div class="cs-cd__t"><i>' + icon(d) + '</i><span>' + text + '</span></div>';
}
function anchor(it, cur) {
var cents = 0;
if (it.original_line_price > it.line_price) cents = it.original_line_price;
else {
var c = (DATA && DATA.cmp) ? DATA.cmp[String(it.variant_id)] : 0;
if (c) cents = c * it.quantity;
}
if (!cents || cents <= it.line_price) return '';
return '<span class="cs-cd__was">' + money(cents, cur) + '</span>';
}

function render(cart) {
var items = cart.items || [], cur = cart.currency || 'USD';
var units = items.reduce(function (n, i) { return n + i.quantity; }, 0);
$('csCdCount').textContent = units ? ' (' + units + ')' : '';
document.querySelectorAll('.cf-cart-count').forEach(function(el){el.textContent=units;});
var bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');if(bubble){bubble.hidden=!units;var count=bubble.querySelector('[aria-hidden]');if(count)count.textContent=units;}

$('csCdRes').hidden = true;
$('csCdGo').disabled = busy || !items.length || pieceUnits(cart) > MAX_PIECES;
var addons = items.reduce(function (n, i) { return n + (i.requires_shipping ? 0 : i.line_price); }, 0);
if (addons > 0) { $('csCdSub').hidden = false; $('csCdSubVal').textContent = money(addons, cur); }
else { $('csCdSub').hidden = true; }

var inVar = {}, varKey = {};
items.forEach(function (i) { inVar[i.variant_id] = true; varKey[i.variant_id] = i.key; });

var capped = atCap(cart) || Date.now() < noticeUntil;
var html = '';
if (Date.now() < soldNoticeUntil) {
html += '<p class="cs-cd__limit">' + icon(IC.hand) + '<span>' + esc(SOLDOUT_MSG) + '</span></p>';
}
if (capped) {
html += '<p class="cs-cd__limit">' + icon(IC.hand) + '<span>' + esc(LIMIT_MSG) + '</span></p>';
}
items.forEach(function (it) {
var free = it.line_price === 0;
var was = anchor(it, cur);
var d = demandFor(it.product_id);
var vl = variantLabel(it);
html += '<div class="cs-cd__item" data-key="' + esc(it.key) + '">' +
'<img class="cs-cd__thumb" src="' + esc(imageURL(it.image, 160)) + '" alt="" width="72" height="72" decoding="async">' +
'<div class="cs-cd__info">' +
'<p class="cs-cd__name">' + esc(it.product_title) + '</p>' +
(vl ? '<p class="cs-cd__var">' + esc(vl) + '</p>' : '') +
'<div class="cs-cd__price">' + was +
(free ? '<span class="cs-cd__tagfree">Free</span>' : money(it.line_price, cur)) + '</div>' +
(d ? '<span class="cs-cd__hot">' + icon(IC.flame) + d + ' ' + esc(DEMAND_LABEL) + '</span>' : '') + '</div>' +
'<div class="cs-cd__ctrl">' +
'<span class="cs-cd__qty">' +
'<button type="button" data-act="dec" aria-label="Decrease">&minus;</button>' +
'<span>' + it.quantity + '</span>' +
'<button type="button" data-act="inc" aria-label="Increase"' +
(capped && it.requires_shipping ? ' disabled' : '') + '>+</button>' +
'</span>' +
'<button type="button" class="cs-cd__rm" data-act="rm">Remove</button>' +
'</div></div>';
});

var itemHTML = html;
html = '';
buildRows(cart).forEach(function (row) {
html += '<div class="cs-cd__sec"><div class="cs-cd__sechead">' + esc(row.title) + '</div>' +
(row.sub ? '<p class="cs-cd__secsub">' + esc(row.sub) + '</p>' : '') +
'<div class="cs-cd__rail">';
row.items.forEach(function (r) {
if (r.out) {
html += card({ img: r.meta.i, title: r.meta.t, out: true,
price: '<span class="cs-cd__outtag">' + esc(SOLDOUT_LABEL) + '</span>',
hot: '', cta: '', disabled: true, attr: '' });
return;
}
var d = demandFor(r.id);
html += card({ img: r.meta.i, title: r.meta.t,
price: (r.meta.c ? '<span class="cs-cd__was">' + money(r.meta.c, cur) + '</span>' : '') +
'<span class="cs-cd__tagfree">Free</span>',
hot: d ? d + ' ' + DEMAND_SHORT : '',
cta: capped ? 'Limit' : 'Add', disabled: capped,
attr: 'data-handle="' + esc(r.meta.h) + '"' });
});
html += '</div></div>';
});

if (SHOW_UPSELLS && UPSELLS.length) {
html += '<div class="cs-cd__sec"><div class="cs-cd__sechead">' + esc(UPSELL_TITLE) + '</div>' +
'<p class="cs-cd__secsub">Sent to your email. Nothing to post.</p><div class="cs-cd__rail">';
UPSELLS.forEach(function (u) {
html += pickCard({ id: u.id, img: u.img, title: u.title, price: u.price, blurb: u.blurb,
on: !!inVar[u.id], key: varKey[u.id] });
});
html += '</div></div>';
}

html += '<div class="cs-cd__trust">' +
trust(IC.shield, TRUST1) + trust(IC.hammer, TRUST2) + trust(IC.truck, TRUST3) + '</div>';

if (!body.firstElementChild) body.innerHTML = '<div class="cs-cd__lines"></div><div class="cs-cd__recommendations"></div>';
if (linesHTML !== itemHTML) {
var active = document.activeElement, activeRow = active && active.closest('[data-key]');
var activeKey = activeRow && activeRow.getAttribute('data-key'), activeAction = active && active.getAttribute('data-act');
body.firstElementChild.innerHTML = itemHTML; linesHTML = itemHTML;
if (activeKey && activeAction) {
var replacement = Array.from(body.querySelectorAll('[data-key]')).find(function(row) { return row.getAttribute('data-key') === activeKey; });
var focusTarget = replacement && replacement.querySelector('[data-act="' + activeAction + '"]');
if (focusTarget) focusTarget.focus({ preventScroll: true });
}
}
if (recommendationsHTML !== html) {
var positions = Array.from(body.querySelectorAll('.cs-cd__rail')).map(function(rail) { return rail.scrollLeft; });
body.lastElementChild.innerHTML = html; recommendationsHTML = html;
body.querySelectorAll('.cs-cd__rail').forEach(function(rail, index) { rail.scrollLeft = positions[index] || 0; });
}
verifyStock();
}
function refresh(force) { return Promise.all([loadData().catch(function() { return null; }), getCart(force)]).then(function(results) { render(results[1]); }).catch(function () { showError('Your order could not be loaded. Please try again.'); }); }
function syncAndRefresh() { return refresh(); }
function showError(message) { var el = $('csCdError'); el.textContent = message || ''; el.hidden = !message; }
function setBusy(v) { busy = v; if(v)showError(''); drawer.setAttribute('aria-busy',String(v)); drawer.classList.toggle('is-busy', v); $('csCdGo').disabled = v || !cartCache || !cartCache.items.length || pieceUnits(cartCache) > MAX_PIECES; if (!v) verifyStock(); }
function post(url, payload) {
setBusy(true); invalidateCart();
return jfetch(url, { method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify(payload) })
.then(function (r) { return r.json().then(function(d){if(!r.ok)throw new Error(d.description || 'Unable to update your order.');return d;}); })
.then(function (cart) { invalidateCart(); if (typeof cart.item_count === 'number') { rememberCart(cart); render(cart); } else return refresh(true); })
.catch(function (e) { showError(e.message || 'Please try again.'); })
.then(function () { setBusy(false); });
}

function addByHandle(handle, btn) {
setBusy(true);
if (btn) btn.textContent = 'Adding…';
return Promise.all([getCart(), getProduct(handle)]).then(function(results) {
var cart = results[0], prod = results[1], pid = pidOfHandle(handle);
if (atCap(cart)) { flagLimit(); render(cart); return; }
var variant = (prod.variants || []).find(function(v) { return v.available; });
if (!variant) { markOut(pid, true); render(cart); return; }
invalidateCart();
return jfetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
.then(function(r) { return r.json().then(function(data) { if (!r.ok) { delete productCache[handle]; throw new Error(data.description || 'Unable to add this piece.'); } return data; }); })
.then(function() { invalidateCart(); markOut(pid, false); return refresh(true); });
}).catch(function(e) { showError(e.message || 'Please try again.'); })
.finally(function() { if (btn && btn.isConnected) { btn.textContent = 'Add'; btn.disabled = cartCache && atCap(cartCache); } setBusy(false); });
}

function goCheckout() {
if (busy) return;
setBusy(true);
return getCart(true).then(function(cart) {
if (!cart.items.length) { render(cart); return; }
if (pieceUnits(cart) > MAX_PIECES) { flagLimit(); return refresh(); }
if (drawer.dataset.checkoutMode === 'custom') {
if (!window.CFCheckoutHandoff) throw new Error('Checkout could not be loaded. Please refresh and try again.');
window.CFCheckoutHandoff.submitCheckout(cart);
} else {
window.location.assign('/checkout');
}
}).catch(function (error) { showError(error.message || 'Please reload your order and try again.'); })
.finally(function () { setBusy(false); });
}
function hookFetch() {
if (!window.fetch || window.__csFetchHooked) return;
window.__csFetchHooked = true;
var orig = window.fetch;
window.fetch = function (input, init) {
var mine = ours;
var url = '';
try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
var bundleRequest = init && init.headers && (init.headers['X-Sunday-Soul-Bundle'] === '1');
var isAdd = !mine && !bundleRequest && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
if (isAdd) invalidateCart();
var p = orig.apply(this, arguments);
if (isAdd) {
p.then(function (r) {
if (!r || r.ok === false) return;
invalidateCart();
if (/\/cart\/add/.test(url)) { open(); syncAndRefresh(); }
else r.clone().json().then(function(cart) { if (typeof cart.item_count === 'number') { rememberCart(cart); render(cart); } else refresh(true); }).catch(function() { refresh(true); });
}).catch(function () {});
}
return p;
};
}

function init() {
drawer = $('csCartDrawer'); veil = $('csCdVeil'); body = $('csCdBody');
if (!drawer) return;
loadOut();

$('csCdClose').addEventListener('click', close);
veil.addEventListener('click', close);
document.addEventListener('keydown', function (e) {
if (!drawer.classList.contains('is-open'))return;
if (e.key === 'Escape') close();
if(e.key==='Tab'){var els=Array.from(drawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(function(el){return el.getClientRects().length;});var first=els[0],last=els[els.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}}
});
$('csCdGo').addEventListener('click', function (e) { e.preventDefault(); goCheckout(); });

body.addEventListener('click', function (e) {
var z = e.target.closest('[data-zoom]');
if (z) {
e.preventDefault();
var thisCard = z.closest('.cs-cd__card');
var wasOpen = thisCard.classList.contains('is-zoom');
body.querySelectorAll('.cs-cd__card.is-zoom').forEach(function (c) {
c.classList.remove('is-zoom');
var b = c.querySelector('[data-zoom]');
if (b) b.setAttribute('aria-expanded', 'false');
});
if (!wasOpen) {
thisCard.classList.add('is-zoom');
z.setAttribute('aria-expanded', 'true');
var image = z.querySelector('img[data-full-src]');
if (image) image.src = image.dataset.fullSrc;
thisCard.scrollIntoView({ block: 'nearest', inline: 'nearest' });
}
return;
}
if (busy) return;
var h = e.target.closest('[data-handle]');
if (h) { h.disabled = true; addByHandle(h.getAttribute('data-handle'), h); return; }
var act = e.target.closest('[data-act]');
if (!act) return;
var row = act.closest('[data-key]'); if (!row) return;
var qtyEl = row.querySelector('.cs-cd__qty span');
var q = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
var k = act.getAttribute('data-act');
var next = k === 'rm' ? 0 : (k === 'inc' ? q + 1 : q - 1);
if (k === 'inc') {
setBusy(true);
getCart().then(function (cart) {
if (atCap(cart)) { flagLimit(); setBusy(false); return refresh(); }
return post('/cart/change.js', { id: row.getAttribute('data-key'), quantity: next });
}).catch(function() { setBusy(false); showError('Please try again.'); });
return;
}
post('/cart/change.js', { id: row.getAttribute('data-key'), quantity: Math.max(0, next) });
});
body.addEventListener('change', function (e) {
var t = e.target.closest('[data-toggle]');
if (!t) return;
if (busy) { t.checked = !t.checked; return; }
var lbl = t.closest('.cs-cd__pick');
var txt = lbl && lbl.querySelector('.cs-cd__picktx');
var cardEl = t.closest('.cs-cd__card');
if (txt) txt.textContent = t.checked ? 'Added' : 'Add';
if (cardEl) cardEl.classList.toggle('is-on', t.checked);
if (t.checked) {
post('/cart/add.js', { items: [{ id: Number(t.getAttribute('data-toggle')), quantity: 1 }] });
} else {
var key = t.getAttribute('data-key');
if (!key) { refresh(); return; }
post('/cart/change.js', { id: key, quantity: 0 });
}
});

function isAddForm(form) {
return form instanceof HTMLFormElement &&
(form.getAttribute('action') || '').toLowerCase().indexOf('/cart/add') !== -1 &&
!form.querySelector('[name="checkout"]');
}
function addFromForm(form) {
if (busy) return;
var fd = new FormData(form);
setBusy(true); open();
getCart().then(function(cart) {
var quantity = Number(fd.get('quantity') || 1);
if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Choose a valid quantity.');
if (pieceUnits(cart) + quantity > MAX_PIECES) { flagLimit(); throw new Error(LIMIT_MSG); }
invalidateCart();
return jfetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
})
.then(function (r) { return r.json().then(function(d){if(!r.ok)throw new Error(d.description || 'Unable to add this piece.');return d;}); })
.then(function () { invalidateCart(); return refresh(true); }).catch(function (e) { showError(e.message || 'Please try again.'); })
.then(function () { setBusy(false); });
}

document.addEventListener('submit', function (e) {
if (!isAddForm(e.target)) return;
e.preventDefault(); e.stopPropagation();
addFromForm(e.target);
}, true);
var nativeSubmit = HTMLFormElement.prototype.submit;
HTMLFormElement.prototype.submit = function () {
if (isAddForm(this)) { addFromForm(this); return; }
return nativeSubmit.apply(this, arguments);
};

document.addEventListener('click', function (e) {
var a = e.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-cart-toggle], [data-cs-cart-open]');
if (!a || a.closest('#csCartDrawer')) return;
e.preventDefault(); e.stopPropagation();
open(); syncAndRefresh();
}, true);

hookFetch();
function warm() { loadData().catch(function() {}); getCart().then(function(cart) { if (DATA && !busy) render(cart); }).catch(function() {}); }
if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 1500 });
else setTimeout(warm, 700);
document.addEventListener('visibilitychange', function() { if (!document.hidden) { cartTime = 0; if (drawer.classList.contains('is-open')) refresh(true); } });
window.addEventListener('pageshow', function(e) { if (e.persisted) { invalidateCart(); refresh(true); } });

window.csCart = { open: function () { open(); syncAndRefresh(); }, close: close, refresh: refresh };
}

var returnFocus=null, previousOverflow='';
function open() {
if (!drawer || drawer.classList.contains('is-open')) { if (drawer) startClock(); return; }
returnFocus=document.activeElement;previousOverflow=document.documentElement.style.overflow;
drawer.hidden = false; veil.hidden = false;
if (cartCache) render(cartCache);
void drawer.offsetWidth;
requestAnimationFrame(function () {
drawer.classList.add('is-open'); veil.classList.add('is-open');
drawer.setAttribute('aria-hidden', 'false');$('csCdClose').focus();
});
document.documentElement.style.overflow = 'hidden';
startClock();
}
function close() {
clearTimeout(stockTimer);
drawer.classList.remove('is-open'); veil.classList.remove('is-open');
drawer.setAttribute('aria-hidden', 'true');
document.documentElement.style.overflow = previousOverflow;if(returnFocus && returnFocus.isConnected)returnFocus.focus();
setTimeout(function () {
if (!drawer.classList.contains('is-open')) { drawer.hidden = true; veil.hidden = true; }
}, 340);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
